export const formatPaymentInput = (amount: number): string => (Math.round(amount * 100) / 100).toFixed(2);

export const validPaymentDate = (value: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
};

export const resolveCustomerRound = <T extends { customer_code?: string | null }>(rounds: T[], code: string): T | undefined =>
  rounds.find(round => round.customer_code === code) || rounds.find(round => !round.customer_code);

export const mergeInvoicePages = <T extends { uuid: string }>(cache: Record<string, T>, rows: T[]): Record<string, T> => {
  const next = { ...cache };
  rows.forEach(row => { next[row.uuid] = row; });
  return next;
};

export const canApproveEvidence = (
  files: Array<{ transfer_amount?: number | string | null; verified_by?: string | null; verified_at?: string | null }>,
  amount: number, method: string,
): boolean => {
  if (!['transfer', 'cheque', 'credit_card'].includes(method)) return true;
  return files.length > 0 && files.every(file => file.verified_by && file.verified_at && file.transfer_amount != null &&
    Number.isFinite(Number(file.transfer_amount)) && Number(file.transfer_amount) > 0) &&
    files.reduce((sum, file) => sum + Math.round(Number(file.transfer_amount) * 100), 0) === Math.round(amount * 100);
};

export const billingRelatedUrl = (kind: 'email' | 'pdf', start: string, end: string, codes: string[]): string => {
  const params = new URLSearchParams({ start_date: start, end_date: end });
  codes.filter(Boolean).forEach(code => params.append('customer_code', code));
  if (kind === 'pdf') { params.set('date_basis', 'invoice_date'); params.set('pdf_mode', 'billing_only'); }
  return `/sales/${kind === 'pdf' ? 'billing-pdf-generator' : 'invoice-email-management'}?${params}`;
};

export const isPdfEvidence = (url: string, name: string): boolean =>
  /^data:application\/pdf[;,]/i.test(url) || /\.pdf$/i.test(name);

/** Keep the exact payload and identity after an uncertain response, even if form state changes. */
export const createPaymentSubmission = <T extends object>(uuid: () => string) => {
  let snapshot: (T & { client_request_id: string }) | null = null;
  return {
    prepare: (payload: T): T & { client_request_id: string } => {
      if (!snapshot) snapshot = { ...payload, client_request_id: uuid() };
      return snapshot;
    },
    restore: (payload: T & { client_request_id: string }) => { snapshot = payload; },
    peek: () => snapshot,
    reset: () => { snapshot = null; },
  };
};
export const newBillingRequestId = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
